export default __webpack_public_path__ + "static/media/footer-payment.f637c441.png";